import { useOpenClose } from '@evertrue/et-components';
import { createContext, useContext, useState, useCallback } from 'react';
import useTwilio from 'components/dialer/voip-services/twilio/hooks/use-twilio';
import PropTypes from 'prop-types';

const GlobalOutreachContext = createContext(() => {});

const GlobalOutreachProvider = ({ children }) => {
  // establish outreach device for Voip Tool. Today, we use Twilio. if we ever replace Twilio, replace it here
  const voipState = useTwilio();

  // State Management of the Quick Interaction Modal, and Data used to populate that modal.
  const [quickInteractionData, setQuickInteractionData] = useState({});
  const [isQuickInteractionOpen, openQuickInteraction, closeQuickInteraction] = useOpenClose();

  // open the modal and update global state to include the data from the outreach attempt
  const openQuickInteractionModalWithData = useCallback(
    (type, args) => {
      const quickInteractionFields = {
        saveLabel: 'Save',
        cancelLabel: 'Skip',
        type,
        ...args,
      };

      // open a modal with the relevant data pre-populated
      setQuickInteractionData(quickInteractionFields);
      openQuickInteraction();
    },
    [openQuickInteraction]
  );

  // any time the quick interaction modal closes, reset the global state to empty
  const closeQuickInteractionWithData = () => {
    closeQuickInteraction();
    setQuickInteractionData({});
  };

  return (
    <GlobalOutreachContext.Provider
      value={{
        quickInteractionData,
        isQuickInteractionOpen,
        closeQuickInteraction: closeQuickInteractionWithData,
        openQuickInteraction: openQuickInteractionModalWithData,
        ...voipState,
      }}
    >
      {children}
    </GlobalOutreachContext.Provider>
  );
};

const useGlobalOutreachProvider = () => {
  const context = useContext(GlobalOutreachContext);
  if (!context) {
    throw new Error('useGlobalOutreachProvider must be used within a GlobalOutreachProvider');
  }
  return context;
};

GlobalOutreachProvider.propTypes = { children: PropTypes.any };

export { GlobalOutreachProvider, GlobalOutreachContext, useGlobalOutreachProvider };
